import React from "react";

import styles from "./MemberCard.module.scss";

const MemberCard = ({ title, link, img }) => {
  return (
    <a target="_blank" href={link} className={styles.MemberCard} rel="noreferrer">
      <p className={styles.Title}>{ title }</p>

      <img className={styles.Image} src={img} alt={title} />
    </a>
  )
}

export default MemberCard;
